import type { AppSpecData, BuilderComponentsData } from '@wix/thunderbolt-symbols'

export const getBuilderComponentsData = (clientSpecMap: Record<string, AppSpecData>): BuilderComponentsData =>
	Object.values(clientSpecMap).reduce((acc, spec: AppSpecData) => {
		const { appDefinitionId, components } = spec
		if (!components) {
			return acc
		}

		components
			.filter((comp) => comp.type === 'EDITOR_REACT_COMPONENT')
			.forEach((comp) => {
				const { componentId, data } = comp
				const { type, resources } = data
				const sdkUrl = resources.sdk?.url
				const serverUrl = resources.server?.url

				acc[type] = {
					appDefinitionId,
					componentId,
					componentUrl: resources?.client?.componentUrl || '',
					cssUrl: resources?.client?.cssUrl || '',
					viewerReducedModel: resources?.viewerReducedModel || '',
					...(sdkUrl && {
						sdkUrl,
					}),
					...(serverUrl && {
						serverUrl,
					}),
				}
			})

		return acc
	}, {} as BuilderComponentsData)
